export default "__VITE_ASSET__BxRfa55s__"